import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CORAL } from '../theme/creamyTokens';

interface NavBadgeProps {
  count: number;
}

/**
 * Small coral count pill, used on MobileBottomNav's "Reservas" tab, on
 * HostToolsMenu's "Reservas" row and on the icon that opens it, to flag
 * unseen incoming bookings (see IncomingBookingsProvider). Pops in/out with a soft
 * fade+scale rather than just appearing/disappearing -- the same creamy
 * motion language as PayoutIssueBanner/Toast's own entry animations -- so a
 * newly arrived booking reads as "just landed" instead of a static counter.
 */
const NavBadge: React.FC<NavBadgeProps> = ({ count }) => (
  <AnimatePresence>
    {count > 0 && (
      <motion.span
        key="nav-badge"
        initial={{ opacity: 0, scale: 0.4 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.4 }}
        transition={{ duration: 0.25, ease: [0.2, 0.8, 0.2, 1] }}
        style={{
          minWidth: 16,
          height: 16,
          padding: '0 4px',
          borderRadius: 999,
          background: CORAL,
          color: '#fff',
          fontSize: 10,
          fontWeight: 700,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
        }}
      >
        {count > 9 ? '9+' : count}
      </motion.span>
    )}
  </AnimatePresence>
);

export default NavBadge;
